import { CyraError } from "./errors";

export function throwApiError(
  error: unknown,
  response: Response,
  fallbackMessage = "The API request could not be completed.",
): never {
  const retryHeader = response.headers.get("retry-after");
  const delay =
    retryHeader === null
      ? Number.NaN
      : /^\d+$/u.test(retryHeader)
        ? Number(retryHeader)
        : Math.ceil((Date.parse(retryHeader) - Date.now()) / 1_000);
  const retry = Number.isFinite(delay) && delay >= 0 ? { retryAfterSeconds: delay } : {};
  if (typeof error === "object" && error !== null && "error" in error) {
    const envelope = error.error;
    if (
      typeof envelope === "object" &&
      envelope !== null &&
      "code" in envelope &&
      "message" in envelope &&
      "requestId" in envelope &&
      typeof envelope.code === "string" &&
      typeof envelope.message === "string" &&
      typeof envelope.requestId === "string"
    ) {
      throw new CyraError({
        code: envelope.code,
        fieldErrors:
          "fieldErrors" in envelope && Array.isArray(envelope.fieldErrors)
            ? envelope.fieldErrors.filter(
                (value): value is { field: string; message: string } =>
                  Boolean(value) &&
                  typeof value.field === "string" &&
                  typeof value.message === "string",
              )
            : [],
        message: envelope.message,
        requestId: envelope.requestId,
        status: response.status,
        ...("mutationDisposition" in envelope && envelope.mutationDisposition === "NOT_APPLIED"
          ? { mutationDisposition: "NOT_APPLIED" as const }
          : {}),
        ...retry,
      });
    }
  }
  throw new CyraError({
    code: `HTTP_${response.status}`,
    message: fallbackMessage,
    requestId: response.headers.get("x-request-id") ?? "unknown",
    status: response.status,
    ...retry,
  });
}
